'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var magicMessages = require('@gig/magic-messages');

var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
function languageQuery() {
  return __async(this, null, function* () {
    return yield window.queryBus.query(magicMessages.LANGUAGE_QUERY);
  });
}
function queryTranslations() {
  return __async(this, null, function* () {
    return yield window.queryBus.query(magicMessages.TRANSLATIONS_QUERY);
  });
}
function queryMappedTranslations() {
  return __async(this, null, function* () {
    const translations = yield queryTranslations();
    return translations.reduce((prev, curr) => Object.assign(prev, { [curr.uniqID || curr.key]: curr.val }), {});
  });
}

exports.languageQuery = languageQuery;
exports.queryMappedTranslations = queryMappedTranslations;
exports.queryTranslations = queryTranslations;
